import { useState, useEffect } from 'react';
import { normalizeCommerInfo } from '../utils/productUtils';

export function useFusionFeatures(selectedProduct) {
  const [commerInfoBlock, setCommerInfoBlock] = useState(null);
  const [tv, setTv] = useState(null);
  const [phone, setPhone] = useState(null);
  const [internet, setInternet] = useState(null);
  const [smartphoneIncluded, setSmartphoneIncluded] = useState(null);

  useEffect(() => {
    if (selectedProduct) {
      setCommerInfoBlock(
        selectedProduct.product.commerInfo.filter(
          eachBlock => !eachBlock.alias.includes('ic_legales')
        )
      );
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (commerInfoBlock) {
      commerInfoBlock.forEach((eachBlock) => {
        if (eachBlock.alias.includes('ic_tv')) {
          setTv(normalizeCommerInfo(eachBlock));
        } else if (eachBlock.alias.includes('ic_movil')) {
          setPhone(normalizeCommerInfo(eachBlock));
        } else if (eachBlock.alias.includes('ic_internet')) {
          setInternet(normalizeCommerInfo(eachBlock));
        } else if (eachBlock.alias.includes('ic_smartphone')) {
          setSmartphoneIncluded(normalizeCommerInfo(eachBlock));
        }
      });
    }
  }, [commerInfoBlock]);

  return {
    tv, phone, internet, smartphoneIncluded,
  };
}
